<template>
  <div class="processing flexcenter">
    <transition>
      <div class="processing-dialog flexcenter">
        <div>処理中...</div>
        <div class="progress"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import common from "@/mixin/common";

export default {
  name: "processing",
  mixins: [
    common
  ],
  mounted: function() {
    this.log("Processing start mounted");
    this.setBodyStylePosition(true);
  },
  beforeDestroy: function() {
    this.setBodyStylePosition(false);
  }
};
</script>

<style lang="scss">
@import "src/assets/style/modal";
</style>



// WEBPACK FOOTER //
// Processing.vue?7938d60a